<script>
  import { roomsState } from '../../js/state.js';
  import { ROOM_COPY_ID, ROOM_COPY_ID_HOVER, ROOM_COPY_ID_COMPLETE } from '../../js/l10n/en_US.js';

  let copyText = ROOM_COPY_ID_HOVER;
  let copyTimeout = null;

  const copyToClipboard = (str) => {
    const el = document.createElement('textarea');
    el.value = str;
    el.setAttribute('readonly', '');
    el.style.position = 'absolute';
    el.style.left = '-9999px';
    document.body.appendChild(el);
    el.select();
    document.execCommand('copy');
    document.body.removeChild(el);
  };

  function copyCode() {
    copyToClipboard($roomsState.current.room_id);
    copyText = ROOM_COPY_ID_COMPLETE;
    clearTimeout(copyTimeout);
    copyTimeout = setTimeout(() => {
      copyText = ROOM_COPY_ID_HOVER;
    }, 4500);
  }
</script>

{#if $roomsState.current !== null && $roomsState.current.room_id}
  <div class="room-invite">
    {ROOM_COPY_ID}
    <span on:click={copyCode} class="room-invite-code">
      <span class="room-code">{$roomsState.current.room_id}</span>
      <span class="hover-text hover-copy">{copyText}</span>
      <i class="icon-content_copy" />
    </span>
  </div>
{/if}
